var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { set, computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { ApplicationFlowService } from '@square/dashboard-protos/models/squareup/sfs/external/services/application_flow/application_flow_service';
import Service, { inject as service } from '@ember/service';
import { v4 as uuid } from 'uuid';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
import { tracked } from '@glimmer/tracking';
import { fromSfsApiControllingIndividual } from '@banking/api/models/onboarding/individual';
import { doAddressLinesEndWithStateAndZipcode } from '@banking/api/utils/address';
let CurrentApplicationFlowService = (_dec = computed('capitalEngineContext.headers'), _dec2 = readOnly('currentApplicationFlow'), _dec3 = computed('currentApplicationFlow.id'), _dec4 = computed('currentApplicationFlow.status'), _dec5 = computed('currentApplicationFlow.accountId'), _dec6 = computed('currentApplicationFlow.individual'), _dec7 = computed('currentApplicationFlow.business'), _dec8 = computed('currentApplicationFlow.controllingIndividuals'), _dec9 = computed('currentApplicationFlow.ineligibleReason'), _dec10 = computed('currentApplicationFlow.bankcBalanceId'), _dec11 = computed('currentApplicationFlow.individual.address'), _dec12 = computed('currentApplicationFlow.business.businessName'), _dec13 = computed('currentApplicationFlow.business.address'), (_class = class CurrentApplicationFlowService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor2, this);
    _initializerDefineProperty(this, "currentApplicationFlow", _descriptor3, this);
    _initializerDefineProperty(this, "didFailIdv", _descriptor4, this);
    // Indicates whether we should show a section for adding/editing beneficial
    // owners. This state is not tracked on the server.
    _initializerDefineProperty(this, "businessHasOtherSignificantOwners", _descriptor5, this);
    _initializerDefineProperty(this, "applicationFlow", _descriptor6, this);
  }
  get client() {
    return ApplicationFlowService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  // NOTE: these are @computed so that change tracking works when currentApplicationFlow is updated
  get id() {
    return this.currentApplicationFlow?.id;
  }

  // NOTE: these are @computed so that change tracking works when currentApplicationFlow is updated
  get status() {
    return this.currentApplicationFlow?.status;
  }

  // NOTE: these are @computed so that change tracking works when currentApplicationFlow is updated
  get accountId() {
    return this.currentApplicationFlow?.accountId;
  }

  // NOTE: these are @computed so that change tracking works when currentApplicationFlow is updated
  get individual() {
    return this.currentApplicationFlow?.individual;
  }
  get business() {
    return this.currentApplicationFlow?.business;
  }
  get controllingIndividuals() {
    return (this.currentApplicationFlow?.controllingIndividuals || []).map(fromSfsApiControllingIndividual);
  }
  get ineligibleReason() {
    return this.currentApplicationFlow?.ineligibleReason;
  }
  get bankcBalanceId() {
    return this.currentApplicationFlow?.bankcBalanceId;
  }
  get individualAddressError() {
    const address = this.currentApplicationFlow?.individual?.address;
    return doAddressLinesEndWithStateAndZipcode(address);
  }
  get businessNameError() {
    const businessName = this.currentApplicationFlow?.business?.businessName || '';
    return businessName.trim().length === 0;
  }
  get businessAddressError() {
    const address = this.currentApplicationFlow?.business?.address;
    return doAddressLinesEndWithStateAndZipcode(address);
  }
  async create() {
    const {
      applicationFlow
    } = await this.client.createApplicationFlow({
      idempotencyKey: uuid()
    });
    if (applicationFlow) {
      this.cacheApplicationFlow(applicationFlow);
    }
    return applicationFlow;
  }
  async retrieve(applicationFlowId) {
    const {
      applicationFlow
    } = await this.client.retrieveApplicationFlow({
      applicationFlowId
    });
    if (applicationFlow) {
      this.cacheApplicationFlow(applicationFlow);
    }
    return applicationFlow;
  }
  async refreshStatus() {
    if (this.id) {
      const {
        applicationFlow
      } = await this.client.retrieveApplicationFlow({
        applicationFlowId: this.id,
        fieldsToInclude: ['status']
      });
      if (applicationFlow) {
        return applicationFlow.status;
      } else {
        throw new Error(`no application flow was found for id: ${this.id}`);
      }
    } else {
      throw new Error('no application flow id was present');
    }
  }
  async submit(applicationFlowUpdate, taxTinType) {
    const {
      applicationFlow
    } = await this.client.submitApplicationFlow({
      idempotencyKey: uuid(),
      applicationFlowId: this.id,
      applicationFlow: applicationFlowUpdate,
      taxTinType
    });
    if (applicationFlow) {
      this.cacheApplicationFlow(applicationFlow);
    }
    return applicationFlow;
  }
  async update(applicationFlowUpdate) {
    const {
      applicationFlow
    } = await this.client.updateApplicationFlow({
      idempotencyKey: uuid(),
      applicationFlow: applicationFlowUpdate
    });
    if (applicationFlow) {
      this.cacheApplicationFlow(applicationFlow);
    }
    return applicationFlow;
  }
  cacheApplicationFlow(applicationFlow) {
    set(this, 'currentApplicationFlow', applicationFlow);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentApplicationFlow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "didFailIdv", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "businessHasOtherSignificantOwners", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "applicationFlow", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "id", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "id"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "status", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "status"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "accountId", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "accountId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "individual", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "individual"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "business", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "business"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "controllingIndividuals", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "controllingIndividuals"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ineligibleReason", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "ineligibleReason"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bankcBalanceId", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "bankcBalanceId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "individualAddressError", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "individualAddressError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "businessNameError", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "businessNameError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "businessAddressError", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "businessAddressError"), _class.prototype)), _class));
export { CurrentApplicationFlowService as default };